import * as _ from "lodash"
import { IMetricDataSet } from "../PA.MetricDataSet.Core/PA.MetricDataSet.IF";
import { IGanttChartMetaData } from '../../client-ui5/PA-Controls/Visualization/GanttChartMetaData'
import {
    IGanttChartOptionsBarDefinition,
    IGanttChartOptionsMetaData
} from '../../client-ui5/PA-Controls/Visualization/GanttChartOptionsMetadata'


export class GanttLayoutMetaDataUtils {

    static convertGanttMD(originalGanttMD: IGanttChartMetaData, dataSet: IMetricDataSet, newOptions: IGanttChartOptionsMetaData, barDefinitions: IGanttChartOptionsBarDefinition[]): IGanttChartMetaData {
        const attributes = _.keyBy(dataSet.DataProvider.getAttributes(), "Id")
        const barDefinition = _.first(_.filter(barDefinitions, bar => bar.id == newOptions.BarDefinitionId))

        if (barDefinition.id_attributeId in attributes) {
            originalGanttMD.ganttGeneration["id_attributeId"] = barDefinition.id_attributeId;
        }

        if (barDefinition.startDate_attributeId in attributes) {
            originalGanttMD.ganttGeneration["startDate_attributeId"] = barDefinition.startDate_attributeId;
        }

        if (barDefinition.endDate_attributeId in attributes) {
            originalGanttMD.ganttGeneration["endDate_attributeId"] = barDefinition.endDate_attributeId;
        }
        if (newOptions.RowProperties.length > 0) {
            if (!("yAxis" in originalGanttMD.ganttGeneration)) {
                originalGanttMD.ganttGeneration["yAxis"] = {
                    group_attributeIds: [],
                    "options": { PA_attributeSort: [] }
                }
            } else if (!("group_attributeIds" in originalGanttMD.ganttGeneration.yAxis))
                originalGanttMD.ganttGeneration.yAxis["group_attributeIds"] = []
            else
                originalGanttMD.ganttGeneration.yAxis.group_attributeIds = []
            if (!('options' in originalGanttMD.ganttGeneration.yAxis))
                originalGanttMD.ganttGeneration.yAxis["options"] = {}
            originalGanttMD.ganttGeneration.yAxis.options["PA_attributeSort"] = []
            for (const row of newOptions.RowProperties) {
                if (row.PA_attributeId in attributes) {
                    originalGanttMD.ganttGeneration.yAxis.group_attributeIds.push(row.PA_attributeId);

                    originalGanttMD.ganttGeneration.yAxis.options.PA_attributeSort.push({
                        PA_attributeId: row.PA_attributeId,
                        descending: row?.sortDescending ? true : false
                    })

                }
            }
        }
        return originalGanttMD
    }


}